import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GeoId } from "../../types/geo.types";
import { RouteConstants } from "../../constants";
import { useCompareService } from "../../services";
import { Button } from "../Shadcn/Button";
import { Typography } from "../Shadcn/Typography";
import { geoState, ptypeState } from "../../states";
import { useRecoilValue, useSetRecoilState } from "recoil";

interface AddToCompareProps {
    isAddedToCompare: boolean;
    geoId: GeoId;
    level: number;
    parent_id: any;
    count: number;
    showNodeWithoutHover?: boolean;
    tooltipPosition: string;
    next?: (any?: any) => void;
    selectedItem?: any;
    geoLevel?: string;
}

const tooltipPositionClasses: Record<string, string> = {
    right: "top-[-13px] left-[127%]",
    left: "top-[-10px] right-[95%] left-auto",
    bottom: "top-[140%] left-[-27%] translate-x-[-50%]",
    above: "bottom-full top-auto left-1/2 translate-x-[-50%] mb-2",
};

export const AddToCompare: React.FC<AddToCompareProps> = ({ isAddedToCompare, geoId, level, count, parent_id=null, showNodeWithoutHover, tooltipPosition, next, selectedItem, geoLevel}) => {
    const navigate = useNavigate();
    const compareService = useCompareService();
    const setselectedGeo = useSetRecoilState(geoState);
    const pType = useRecoilValue(ptypeState);
    const [isHovered, setIsHovered] = useState(false);

    const handleCompareAction = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (selectedItem) {
            const { geo_id, parent, grand_parent } = selectedItem;
            let selected: any = { country : "EW-IN-IND-22-0" };
            if (grand_parent) {
                selected = { ...selected, state: grand_parent.geo_id, district: parent.geo_id, sub_district: geo_id };
            } else if (parent) {
                selected = { ...selected, state: parent.geo_id, district: geo_id };
            } else {
                selected = { ...selected, state: geo_id };
            }
            setselectedGeo(selected);
        }
        if (!isAddedToCompare) {
            if (count >= 9) return;
            const payload = {
                addToCompare: [{ geoId, level, ...(level === 5 && { parent_id }), pType: level === -1 && geoLevel ? geoLevel: level === -1 ? pType : geoLevel ? geoLevel : pType === "RelationshipManager"? "Relationship Manager" : pType }]
            }
            await compareService.postCompreList(payload);
        } else {
            navigate(RouteConstants.compare);
        }
        next && next();
    }

    const positionClass = tooltipPositionClasses[tooltipPosition] ?? "top-full left-0 mt-1";

    return (
        <div
            className="relative inline-flex"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Button
                variant="ghost"
                size="small"
                onClick={handleCompareAction}
                disabled={!isAddedToCompare && count >= 9}
                className={showNodeWithoutHover ? "visible" : "add-to-compare"}
            >
                {isAddedToCompare ? "✓ View comparisons" : "+ Add to compare"}
            </Button>
            {count >= 9 && !isAddedToCompare && isHovered && (
                <div className={`absolute z-[999999] w-[220px] bg-white rounded p-2 shadow-md whitespace-normal break-words ${positionClass}`}>
                    <Typography variant="b3" className="text-start text-muted-foreground">
                        You have reached the limit of 9 regions. Remove some to add more.
                    </Typography>
                </div>
            )}
        </div>
    );
}